import { type PropsWithChildren } from 'react';

import { type CustomFieldFilterType, type FilterType } from '~/components/FiltersMenu/types';
import { SINGLE_FILTER_CARD } from '~/constants/testIDs';

export type SingleFilterContainerProps = {
  currentFilter: FilterType;
  currentCustomField?: CustomFieldFilterType;
  onClearClick?: () => void;
  onApplyClick?: () => void;
  hasValues?: boolean;
};

export const SingleFilterContainer = ({
  currentFilter,
  currentCustomField,
  children,
}: PropsWithChildren<SingleFilterContainerProps>) => {
  const testId = currentCustomField?.id
    ? `${SINGLE_FILTER_CARD}-${currentCustomField.name}`
    : `${SINGLE_FILTER_CARD}-${currentFilter}`;

  return (
    <div className="p-0" data-testid={testId}>
      {children}
      {/* This is a work around for the Select dropdown bug. Select needs atleast 1px below the component
        to render the dropdown properly. */}
      <div className="h-px" />
    </div>
  );
};
